//  /src/config/config.js

//  elenco di ShortNameOption da valutare in fase di onboarding
export const initOptions = [
  'FILTER',
  'NL',
  'SMS',
  'USER',
  'PRIVACYBLOCK',
  'GEST',
  'DELSTATS',
  'WHITELABEL',
  'ENGAGEMENT',
]

export const routesAccessConditions = {
  test: 'uo:FILTER',
  filter: 'uo:FILTER AND co:FILTER',
  profile:
    '(uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)',
  activity:
    '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)) AND uo:NL',
  engagement: 'co:DELSTATS OR co:ENGAGEMENT',
  engagementUpselling: 'uo:FILTER AND co:FILTER',
  geolocation:
    '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)) AND uo:NL',
  device:
    '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER))',
  categories: 'uo:FILTER',
  newFilter: 'uo:FILTER AND co:FILTER',
  deleteFilter: 'uo:FILTER AND co:FILTER',
  showEmail: 'uo:NL AND uo:USER AND NOT uo:PRIVACYBLOCK',
  showSms: 'uo:SMS AND uo:USER AND NOT uo:PRIVACYBLOCK',
  combinedFilterForm: 'uo:FILTER AND co:FILTER',
}

export const pendoApiKey = 'da1c8b4e-431b-48c0-5e7e-69e9d34ca1b2'

//  numero massimo di condizioni per filtro
export const conditionLimitValue = 20

export const datePickerDateFormat = 'yyyy-MM-dd'

//  numero massimo di giorni per attitivò di invio/lettura messaggi
export const retentionDays = 15

//  numero massimo di elementi in componenti Chosen
export const msgInChosenLimit = 100

export const MAX_SELECT_ITEMS = 100

export const notifySessionPeriod = 5000 // 5s

export const APP_CLIENT_ID = '988daba5-0d7e-4e73-903e-1879a183c1ad'
